import React from "react"

import t from "../locale"

const OfficesFloorSchema = ({ lang, tab }) => {
  return (
    <div className="offices-floor-schema__wrapper">
      <img
        className="img-fluid"
        src={require("../assets/images/offices-floor-schema.jpg")}
        alt=""
      />
      <button
        className={`offices-floor-schema__wrapper-ico offices-floor-schema__wrapper-ico--1`}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: t(
              "3,2m - height to slab <br /> 2,7m - to suspended ceiling",
              lang
            ),
          }}
        />
      </button>
      <button
        className={`offices-floor-schema__wrapper-ico offices-floor-schema__wrapper-ico--2`}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: t("Openable windows", lang),
          }}
        />
      </button>
      <button
        className={`offices-floor-schema__wrapper-ico offices-floor-schema__wrapper-ico--3`}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: t("Raised technical floor", lang),
          }}
        />
      </button>
      <button
        className={`offices-floor-schema__wrapper-ico offices-floor-schema__wrapper-ico--4`}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: t("HVAC system <br /> air conditioning", lang),
          }}
        />
      </button>
      <button
        className={`offices-floor-schema__wrapper-ico offices-floor-schema__wrapper-ico--6`}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: t("Suspended ceiling (optional)", lang),
          }}
        />
      </button>
      <button
        className={`offices-floor-schema__wrapper-ico offices-floor-schema__wrapper-ico--7`}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: t("Min. 7,5 sqm workspace / <br /> 1 person", lang),
          }}
        />
      </button>
      <button
        className={`offices-floor-schema__wrapper-ico offices-floor-schema__wrapper-ico--8`}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: t("Floorboxes / IT facilities", lang),
          }}
        />
      </button>
      {tab === "1" || tab === "11" ? (
        <button
          className={`offices-floor-schema__wrapper-ico offices-floor-schema__wrapper-ico--9`}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: t("Sprinklers", lang),
            }}
          />
        </button>
      ) : (
        ""
      )}
    </div>
  )
}

export default OfficesFloorSchema
